import { typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 10px;
  padding-left: 40px;

  &:before {
    background: ${p => (p.theme.isDark
    ? 'linear-gradient(179.73deg, rgba(50, 50, 50, 0) 0.28%, #282828 98.3%)'
    : 'linear-gradient(152.13deg, rgba(246, 248, 250, 0) 20.45%, rgba(238, 238, 251, 0.33) 42.37%, #E3F1FA 77.56%, #F0F7F8 98.45%)')};
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
`;

export const Title = styled.div`
  ${typo.body500}
`;

export const ImageContainer = styled.div`
  position: relative;
  margin-top: 28px;
`;

export const Image = styled.img`
  position: absolute;
  left: -8px;
  top: 0;
  max-width: 568px;
`;
